import Http from '../request/Http';

export function getDepts(page, pagesize) {
  return Http.get('/depts', {
    page,
    pagesize,
  });
}

export function getDeptsInTree() {
  return Http.get('/depts/tree');
}

export function createDept(dept) {
  return Http.post('/depts', dept);
}

export function updateDept(dept) {
  return Http.put(`/depts/${dept.deptid}`, dept);
}

export function deleteDept(deptid) {
  return Http.delete(`/depts/${deptid}`);
}

export function getDeptsBin(page, pagesize) {
  // TODO: 这个地方的命名应该是bin
  return Http.get('/depts/bin', {
    page,
    pagesize,
  });
}

export function deleteDeptsFromBin(deptids) {
  return Http.delete(`/depts/bin/${deptids.join(',')}`);
}

export function recoverDeptsFromBin(deptids) {
  return Http.post(`/depts/bin/${deptids.join(',')}`);
}

export function getFingers(dept) {
  return Http.get(`/depts/${dept.deptid}/fingers`);
}
